// extracted by mini-css-extract-plugin
export default {"container":"CreateObservation_container__zxdqf","active":"CreateObservation_active__K3SF9"};